import React from "react";
import { makeStyles, Button, Box, CircularProgress, withStyles, Typography } from "@material-ui/core";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { StyledTextField } from "./StyledTextField";
import { useRouter } from "next/router";
import { getTrackerField } from "lib/ga";
import { customerIoSubscription } from "helpers/customerIoHelpers";
import moment from "moment";

const validateSchema = Yup.object().shape({
  email: Yup.string().email("Cette adresse email n'est pas valide").required("Merci de remplir ce champ"),
});

const SubscribeNewsletter = () => {
  const router = useRouter();
  const handleSubscribeNewsletter = async (values, { setSubmitting, setStatus, resetForm }) => {
    const data = {
      identifyData: {
        id: values.email,
        email: values.email,
      },
      subscribeData: {
        "Optin NL": "subscribed",
        source: `API-Page - ${router.pathname}`,
        signed_up_at: moment().toISOString(),
        client_id_google: getTrackerField(),
        welcome_sequence: "",
      },
    };
    return customerIoSubscription(data.identifyData, data.subscribeData).then((response) => {
      if (response.status === 200) {
        resetForm({ email: "" });
        setStatus({ success: true });
      } else {
        resetForm({ email: "" });
        setStatus({ success: false });
        setSubmitting(false);
        console.error(response);
      }
    });
  };
  const classes = useStyles();
  const StyledButton = () => (
    <Button type="submit" className={classes.button} variant="contained" color="white">
      Ok
    </Button>
  );

  const CircularProgressStyled = withStyles((theme) => ({
    root: {
      height: 10,
      borderRadius: 5,
      color: theme.palette.primary,
      marginLeft: 5,
    },
  }))(CircularProgress);

  return (
    <Formik
      initialValues={{
        email: "",
      }}
      onSubmit={handleSubscribeNewsletter}
      validationSchema={validateSchema}
    >
      {({ isSubmitting }) => (
        <Form>
          <Field name="email">
            {({ field: { name, onChange, value } }) => {
              return (
                <Box className={classes.container}>
                  <StyledTextField
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder="Email"
                    InputProps={{ endAdornment: isSubmitting ? <CircularProgressStyled /> : <StyledButton /> }}
                  />
                  <Typography variant="caption" className={classes.errorMsg}>
                    <ErrorMessage name="email" />
                  </Typography>
                </Box>
              );
            }}
          </Field>
        </Form>
      )}
    </Formik>
  );
};

export default SubscribeNewsletter;

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: "white",
    color: "#2B3B5C",
    height: theme.spacing(5),
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "&:hover::after": {
      backgroundColor: "white",
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
  },
  errorMsg: {
    color: "red",
    marginBottom: theme.spacing(1),
  },
}));
